import React from "react";
import "./About.css";
import { motion } from "framer-motion";
import CODE from "../../assets/code.jpg";
import { AboutfadeUp } from "../../animations/index.js";

const ProfileImage = () => {
  return (
    <motion.div className="about__me" variants={AboutfadeUp}>
      <div className="about__me-image">
        <img src={CODE} alt="About" />
      </div>
    </motion.div>
  );
};

export default ProfileImage;
